{/* Auto-generated icon - do not edit */}
import React from 'react'

interface RectangleIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const RectangleIcon = React.forwardRef<SVGSVGElement, RectangleIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 127 86"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M64.6255 1.09953C81.2713 1.09953 97.917 1.10406 114.563 1.11311C116.686 1.09649 118.808 1.20445 120.918 1.43642C124.588 1.87612 126.448 4.01772 126.451 7.69697C126.451 10.1295 126.294 12.5621 126.245 14.9953C126.012 26.7166 125.86 38.4398 125.546 50.1591C125.305 59.1082 125.293 68.0834 123.731 76.9453C123.447 78.4622 123.033 79.9527 122.495 81.4011C121.525 84.0962 119.576 85.3933 116.624 85.4101C95.5112 85.5395 74.3987 85.7509 53.2865 85.8563C38.989 85.9274 24.6848 85.8679 10.3848 85.8647C9.37943 85.8647 8.37039 85.8964 7.36892 85.8304C3.00266 85.544 1.03103 83.2705 1.12699 78.8961C1.32807 69.718 1.52713 60.5398 1.60547 51.3604C1.70471 39.7446 1.586 28.1268 1.76423 16.5129C1.82951 12.2136 2.41688 7.91689 2.87388 3.6298C3.16962 0.844825 3.84813 0.194983 6.70108 0.194336C12.3808 0.194336 18.0606 0.403776 23.7443 0.419294C37.3726 0.456798 51.0002 0.431608 64.6278 0.431608C64.6265 0.654474 64.6255 0.877098 64.6255 1.09953ZM114.394 76.966C115.644 72.1474 117.276 15.3691 116.34 11.5482C80.448 10.7186 44.5269 11.7901 8.68545 10.0882C8.15599 13.4118 9.55773 75.5137 10.2341 77.8007C44.8521 77.9178 79.5556 78.0943 114.393 76.9673L114.394 76.966Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="126" height="86" fill={color} transform="translate(0.777344)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

RectangleIcon.displayName = 'RectangleIcon'
